<template>
  <div class="enroll-history--container">
    <div class="enroll-history--show-btn text-center">
      <div @click="toggleShowList" v-if="list.length" class="btn btn-sm btn-outline-info">
      <span v-if="!showList">
        Показать историю
        <f-awesome icon="arrow-down"></f-awesome>
      </span>
        <span v-if="showList">
        Скрыть историю
        <f-awesome icon="arrow-up"></f-awesome>
      </span>
      </div>
    </div>
    <div v-if="showList && list.length" class="enroll-history--table">
      <div class="table--container">
        <div class="table--header">
          <div class="name">Изменение/Событие</div>
          <div class="number">Кем создано</div>
          <div class="text">Дата, время</div>
        </div>
        <div class="table--rows">
          <div class="table--row" v-for="item in list" :key="item.id">
            <div class="name">{{item.history_text}}</div>
            <div class="number">{{getUpdatedLogin(item.updated_login)}}</div>
            <div class="text">{{datetimeToRus(item.updated_datetime)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Formatter from "../../../libraries/Formatter";

const formatter = new Formatter();

export default {
  name: "EnrollHistory",
  components: {},
  data() {
    return {
      showList: false
    };
  },
  props: {
    list: Array
  },
  watch: {

  },
  methods: {
    getUpdatedLogin(login){
      if(login == 'online'){
        return 'Клиентом самостоятельно, через страницу записи';
      }else if(login == 'system'){
        return 'enroller';
      }else{
        return login;
      }
    },
    datetimeToRus(datetime){
      return formatter.datetimeToRus(datetime);
    },
    toggleShowList(){
      this.showList = !this.showList;
    }
  },
  created() {}
};
</script>

<style scoped lang="less">

</style>
